import React, { useState, useEffect } from 'react'
import { Grid } from '@material-ui/core'
import MaterialTable from 'material-table'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { getTechnicalAssistanceReceived } from '../../../../../../services/AsistenciaTecnica/get'

export const Table17 = (props) => {
  const { TechnicalAssistanceReceivedNumber, IdTechnicalAssistanceAnswer } =
    props
  const [data, setData] = useState([])

  const getTechnicalAssistanceReceivedList = async () => {
    try {
      const response = await getTechnicalAssistanceReceived(
        IdTechnicalAssistanceAnswer,
      )
      if (response.Success) {
        setData(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      IdTechnicalAssistanceAnswer !== '' &&
      IdTechnicalAssistanceAnswer !== null &&
      IdTechnicalAssistanceAnswer !== undefined
    )
      getTechnicalAssistanceReceivedList()
  }, [IdTechnicalAssistanceAnswer, TechnicalAssistanceReceivedNumber])

  const columns = [
    {
      title: 'Título Asistencia Técnica',
      field: 'TechnicalAssistanceTitle',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Ente Financiador',
      field: 'FundingEntity',
      sorting: false,
      filtering: false,
    },
  ]

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={data}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),

              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            icons={{
              Edit: () => <EditIcon style={{ color: '#0d53ad' }} />,
              Delete: () => <DeleteIcon style={{ color: 'red' }} />,
            }}
          />
        </Grid>
      </Grid>
    </>
  )
}
